import { API_ORIGIN, API_V1_URL } from "../../services/api";

/** @deprecated Prefer API_ENDPOINTS/apiClient from services/api. */
const URLS = {
  DEV: `${API_ORIGIN}/`,
  API: API_V1_URL,
};

export { URLS };
  
